import { render, staticRenderFns } from "./Step2OpenAccount.vue?vue&type=template&id=48f9f91c&scoped=true"
import script from "./Step2OpenAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./Step2OpenAccount.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Step2OpenAccount.vue?vue&type=style&index=0&id=48f9f91c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f9f91c",
  null
  
)

export default component.exports